import * as React from 'react';
import { type ReactNode } from 'react';
import { ScreenContainer } from 'smoothie';

const IncomeSplitSubscreenWrapper = ({
    header,
    children,
}: {
    header: string;
    children: ReactNode;
}) => {
    return (
        <ScreenContainer title={header} hasBackButton={true}>
            {children}
        </ScreenContainer>
    );
};

export default IncomeSplitSubscreenWrapper;
